import React from 'react';
import {PageTitle} from '../../../../_metronic/layout/core';
import {createSearchParams, useNavigate} from 'react-router-dom';
import Button from "react-bootstrap/Button";
import {useSearchParams} from 'react-router-dom';
import "../../Styles/Connexion/ConsommationLTE.css";
import {ProgressBar} from 'react-bootstrap';
import {useGetConsommation} from '../../Hooks/ManageConsommation';
import {useGetServiceInfo} from '../../Hooks/ServiceManager';
import { ListService } from '../../Types/service';
import Loading from '../../../../app/common/components/Loading';
import { DisplaySite }  from '../../Helpers/ServiceHelper';
import {Card} from 'react-bootstrap'; 
import Level3Title  from '../../../../app/common/components/title/Level3Title';


const ConsommationLTE = (): JSX.Element => {

    const [searchParams] = useSearchParams();
    const navigate = useNavigate();

    const cisId: string = searchParams.get('cisId') ?? '';
    const { data:dataService , isError:isErrorService, isLoading:loadingService } = useGetServiceInfo(cisId);
    const { data , isError, isLoading } = useGetConsommation(cisId);

    let typeRouter = dataService?.router?.type ;
    let idRouter = dataService?.router?.data?.cis_id ;

    const { current = 0, limit = 0, unit = '' } = data ?? { current: 0, limit: 0, unit: '' };
    const percentage =  limit > 0 ? (current / limit) * 100 : 0;

    let variant = 'success';
    let completionRate = Math.round(100 * current / limit);
    if (completionRate >= 75 && completionRate < 90) {
        variant = 'info';
    }
    if (completionRate >= 90 && completionRate < 99) {
        variant = 'warning';
    }
    if (completionRate >= 99) {
        variant = 'danger';
    }
    if (limit === 0) {
        completionRate = 0;
        variant = 'success';
    }

    const rate = Math.min(100, completionRate);

    const formatDataSize = (value: number, unit: string): { value: string; unit: string } => {
        const valueInBytes = unit.toLowerCase() === 'gb' ? value * 1024 : value;

        if (valueInBytes >= 1024) {
            return {
                value: (valueInBytes / 1024).toFixed(2),
                unit: 'GB'
            };
        }
        return {
            value: valueInBytes.toFixed(2),
            unit: 'MB'
        };
    };

    const configurationRouter = () => {
        const searchParams = new URLSearchParams();
        searchParams.append('routerId', idRouter ? idRouter : "-1" );
        searchParams.append('site', dataService?.site?.id ? dataService?.site.id.toString() : "");
        navigate({
            pathname: `/support`,
            search: createSearchParams(searchParams).toString(),
        });
    }

    const DisplayBu = (service: ListService|null) => {
        if(service == null ) return '';
        let title = `${service.buId} - ${service.codeX3} - ${service.buName}`;
        return title;
    }

    const currentFormatted = formatDataSize(current, unit);
    const limitFormatted = formatDataSize(limit, unit);

    return (
      <>
        <div className="consommation-lte-container">

            { dataService != null  && (<div>
                <PageTitle breadcrumbs={[]}>
                    {dataService?.link_name}
                </PageTitle>

                { typeRouter === "Microtik" && idRouter !== undefined && (<Button style={{marginLeft: '10px',border:"1px solid gray"}} variant="outline-secondary" onClick={() => configurationRouter()}>
                    <i
                        style={{ margin:5, cursor: 'pointer', fontSize : '16px' }}
                        className="fa fa-cog"
                    ></i>
                    Configurer mon routeur
                </Button>)}

                <div className="row g-4 mt-1">
                    <div className="col-md-6">
                        <Card className="DetailsTelephonie h-100">
                            <Card.Header>
                            <Card.Title>
                                <Level3Title title="Informations générales" />
                            </Card.Title>
                            </Card.Header>
                            <Card.Body>
                            <div className="info-row">
                                <span className="info-label">BU :</span>
                                <span className="info-value">{DisplayBu(dataService)}</span>
                            </div>
                            <div className="info-row">
                                <span className="info-label">Site :</span>
                                <span className="info-value">{DisplaySite(dataService)}</span>
                            </div>
                            <div className="info-row">
                                <span className="info-label">Service :</span>
                                <span className="info-value">{dataService?.serviceId + ' ' + dataService?.serviceName }</span>
                            </div>
                            </Card.Body>
                        </Card>
                    </div>

                    {data && (
                    <div className="col-md-6">
                        <Card className="DetailsTelephonie h-100">
                            <Card.Header>
                            <Card.Title>
                                <Level3Title title="Consommation LTE" />
                            </Card.Title>
                            </Card.Header>
                            <Card.Body>
                                <div className="metrics">
                                    <div className="metric">
                                    <span className="label">Utilisation actuelle</span>
                                    <span className="value">
                                        {currentFormatted.value} {currentFormatted.unit}
                                    </span>
                                    </div>
                                    <div className="metric">
                                    <span className="label">Limite</span>
                                    <span className="value">
                                        {limitFormatted.value} {limitFormatted.unit}
                                    </span>
                                    </div>
                                    <div className="metric">
                                    <span className="label">Pourcentage</span>
                                    <span className="value">
                                        {percentage.toFixed(2)} %
                                    </span>
                                    </div>
                                </div>

                                <div style={{width: '100%'}}>
                                    <ProgressBar now={rate} variant={variant}/>
                                </div>

                                <div className="progress-legend">
                                    <span>{currentFormatted.value} {currentFormatted.unit}</span>
                                    <span>{limitFormatted.value} {limitFormatted.unit}</span>
                                </div>
                            </Card.Body>
                        </Card>
                    </div>
                    )}
                </div>

            </div>
            )}

            { (isError || isErrorService )  && (
                <p>
                Erreur interne veuillez contacter votre service client
                </p>
            )}

            {(isLoading || loadingService) && (
                <Loading />
            )}

        </div>
      </>
    );
  }
;

export default ConsommationLTE;
